import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/system';

// Définition de l'animation slide-in
const slideIn = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export default function ToastMessages({ isOpen, handleClose, data, severity }) {
  // Définir les styles en fonction de la gravité
  const getStyles = () => {
    switch (severity) {
      case 'success':
        return {
          borderColor: '#00c853', // Vert vif
          iconColor: '#00c853',
          textColor: '#00c853',
        };
      case 'error':
        return {
          borderColor: '#d50000', // Rouge vif
          iconColor: '#d50000',
          textColor: '#d50000',
        };
      case 'warning':
        return {
          borderColor: '#ff6d00', // Orange vif
          iconColor: '#ff6d00',
          textColor: '#ff6d00',
        };
      default:
        return {
          borderColor: '#616161', // Gris
          iconColor: '#616161',
          textColor: '#616161',
        };
    }
  };

  const { borderColor, iconColor, textColor } = getStyles();

  // Sélectionner l'icône en fonction de la gravité
  const getIcon = () => {
    switch (severity) {
      case 'success':
        return <CheckCircleIcon sx={{ fontSize: 28, color: iconColor }} />;
      case 'error':
        return <ErrorIcon sx={{ fontSize: 28, color: iconColor }} />;
      case 'warning':
        return <WarningIcon sx={{ fontSize: 28, color: iconColor }} />;
      default:
        return <ErrorIcon sx={{ fontSize: 28, color: iconColor }} />;
    }
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'white', // Fond transparent
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
          minWidth: '220px',
          maxWidth: '350px',
          padding: '8px',
          animation: `${slideIn} 0.3s ease-out`,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: '40px',
            height: '40px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            marginRight: '8px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
          }}
        >
          {getIcon()}
        </Box>

        {/* Texte du message */}
        <Typography
          variant="body2"
          sx={{
            color: textColor,
            fontWeight: 600,
            fontSize: '13px',
            flexGrow: 1,
            wordBreak: 'break-word',
            paddingRight: '8px',
          }}
        >
          {data}
        </Typography>
      </Box>
    </Snackbar>
  );
}